import { getParameterByName } from './getParameterByName'
import { prettyLog } from './prettyLog'

const MAX_ATTEMPTS = 50
const POLL_INTERVAL_MS = 200

function shouldLogPpid() {
  return getParameterByName('logPpid') === 'true'
}

/**
 * GAM only recognizes ppid (used for frequency capping) when it's set on the
 * IMA SDK's own settings singleton (google.ima.settings.setPpid) before an ad
 * request fires. Putting ppid in an ad tag URL, or on a wrapper player's own
 * config object (e.g. Kaltura Playkit's `plugins.ima.ppid`), is not enough —
 * GAM still reports it as Missing. Kaltura Playkit loads the real
 * google.ima SDK internally and asynchronously, with no callback exposed to
 * us for when it's ready, so this polls for it instead.
 *
 * `?logPpid=true` logs how long the wait actually took (in ms), so a real
 * ad-enabled test can compare that against the Network tab's timing to
 * confirm whether this beats Kaltura's first ad request or loses the race.
 */
export function setImaPpid(ppid: string) {
  const startedAt = performance.now()
  let attempts = 0
  const trySet = () => {
    const imaSettings = window.google?.ima?.settings
    if (imaSettings) {
      imaSettings.setPpid(ppid)
      if (shouldLogPpid()) {
        prettyLog(
          'setImaPpid',
          { ppid, waitedMs: Math.round(performance.now() - startedAt) },
          'info'
        )
      }
      return
    }
    attempts += 1
    if (attempts < MAX_ATTEMPTS) {
      setTimeout(trySet, POLL_INTERVAL_MS)
    } else if (shouldLogPpid()) {
      prettyLog(
        'setImaPpid',
        {
          ppid,
          gaveUp: true,
          waitedMs: Math.round(performance.now() - startedAt),
        },
        'error'
      )
    }
  }
  trySet()
}
